/* ond-dr3.js (18-10-2026, thẻ #2, vòng motion 18-10) — hành vi các section -dr3. Một file, tự chặn chạy 2 lần, mọi trạng thái ẩn do JS đặt
 * (JS hỏng → trang vẫn đủ chữ/ảnh), prefers-reduced-motion → trạng thái cuối, không tự chạy. Chỉ transform/opacity.
 *   [data-d3-rv]        tiêu đề hiện theo dòng / sao tô dần (thêm .d3-armed rồi .is-in khi vào khung)
 *   .d3-tk              dải chạy chữ: dừng khi ra khỏi màn
 *   [data-d3-frames]    sân khấu tối: khung Blender nền trong suốt chạy theo cuộn (clearRect mỗi khung), vòng xung chỉ chạy khi đang thấy
 *   [data-d3-mt]        trình phát cơ chế: tab + video + thanh tiến độ, tự sang tab kế khi hết video; khách bấm thì dừng tự chạy và lặp tab đó
 *   [data-d3-tl]        timeline: crossfade 4 mốc, tự chạy MỘT lượt khi vào khung rồi nhường khách (bấm chip / vuốt ảnh)
 *   [data-d3-ring]      vòng 90 ngày tô theo cuộn + mốc sáng dần
 *   .d3-det             ô chi tiết nghiêng 3D theo con trỏ (chỉ chuột) */
(() => {
  if (window.__od3) return; window.__od3 = 1;
  const mm = (q) => !!(window.matchMedia && matchMedia(q).matches);
  const still = mm('(prefers-reduced-motion: reduce)');
  const phone = mm('(max-width: 749px)');
  const conn = navigator.connection || {};
  const lite = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '') || (navigator.deviceMemory || 8) <= 1;
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const clamp = (x) => Math.min(1, Math.max(0, x));
  const watch = (el, cb, opt) => {
    if (!('IntersectionObserver' in window)) { cb(true); return null; }
    const o = new IntersectionObserver((es) => es.forEach((e) => cb(e.isIntersecting, o)), opt || { threshold: 0.2 });
    o.observe(el); return o;
  };
  const onScroll = (fn) => { let raf = 0; const q = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; fn(); }); }; addEventListener('scroll', q, { passive: true }); addEventListener('resize', q, { passive: true }); q(); return q; };

  /* ---------- 1. hiện theo dòng ---------- */
  function reveal(root) {
    $$('[data-d3-rv]', root).forEach((el) => {
      if (el.__d3 || still) return; el.__d3 = 1;
      el.classList.add('d3-armed');
      watch(el, (on, o) => { if (on) { requestAnimationFrame(() => el.classList.add('is-in')); if (o) o.disconnect(); } }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });
    });
  }

  /* ---------- 2. dải chạy chữ ---------- */
  function ticker(root) { $$('.d3-tk', root).forEach((tk) => { if (tk.__d3) return; tk.__d3 = 1; watch(tk, (on) => tk.classList.toggle('is-off', !on), { threshold: 0 }); }); }

  /* ---------- 3. sân khấu tối: khung trong suốt theo cuộn ---------- */
  function stage(root) {
    $$('[data-d3-frames]', root).forEach((fig) => {
      if (fig.__d3) return; fig.__d3 = 1;
      watch(fig, (on) => fig.classList.toggle('is-live', on && !still), { threshold: 0.05 });
      if (still || lite) return;
      const base = fig.dataset.base, first = +fig.dataset.first || 1, n = +fig.dataset.count || 36, STEP = 2, W = phone ? 720 : 960;
      const cv = fig.querySelector('canvas'); if (!cv || !base) return;
      const idx = []; for (let i = 0; i < n; i += STEP) idx.push(first + i);
      if (idx[idx.length - 1] !== first + n - 1) idx.push(first + n - 1);
      cv.width = cv.height = W; const ctx = cv.getContext('2d');
      const imgs = new Array(idx.length).fill(null); let shown = -1, want = 0, loaded = false;
      const draw = () => {
        let j = want; while (j >= 0 && !imgs[j]) j--;
        if (j < 0 || j === shown) return;
        ctx.clearRect(0, 0, W, W); ctx.drawImage(imgs[j], 0, 0, W, W); shown = j;   // nền trong suốt: không xoá là khung chồng khung
        fig.classList.add('is-frames');
      };
      const load = () => {
        if (loaded) return; loaded = true;
        idx.forEach((f, k) => { const im = new Image(); im.decoding = 'async'; im.onload = () => { imgs[k] = im; draw(); }; im.src = `${base}${String(f).padStart(3, '0')}.webp?width=${W}`; });
      };
      const tick = () => {
        if (!loaded) return;
        const r = fig.getBoundingClientRect(), vh = innerHeight;
        if (r.bottom < -80 || r.top > vh + 80) return;
        want = Math.round(clamp((vh * 0.92 - r.top) / (vh * 0.62)) * (idx.length - 1)); draw();
      };
      watch(fig, (on, o) => { if (on) { load(); tick(); if (o) o.disconnect(); } }, { rootMargin: '150% 0px' });
      onScroll(tick);
    });
  }

  /* ---------- 4. trình phát cơ chế dạng tab ---------- */
  function mtabs(root) {
    $$('[data-d3-mt]', root).forEach((sec) => {
      if (sec.__d3) return; sec.__d3 = 1;
      const items = $$('.d3-mt__item', sec), panes = $$('.d3-mt__pane', sec), n = items.length; if (!n) return;
      const tabs = items.map((it) => it.querySelector('[role="tab"]'));
      const bars = items.map((it) => it.querySelector('.d3-mt__bar i'));
      const vids = panes.map((p) => p.querySelector('video'));
      const notes = $$('.d3-mt__note', sec);
      const cap = sec.querySelector('.d3-mt__cap'), capT = cap && cap.querySelector('span');
      const caps = items.map((it) => (it.dataset.caps || '').split(/\n/).map((l) => { const k = l.indexOf('|'); return k > 0 ? { t: parseFloat(l.slice(0, k)) || 0, s: l.slice(k + 1).trim() } : null; }).filter(Boolean));
      let cur = 0, auto = !still, seen = false, raf = 0;
      // clip phải chạy như GIF: trình duyệt / webview nào ép mở trình phát toàn màn (có nút play + tua) thì đóng ngay, dừng hẳn video
      // trong phiên đó, để ảnh tĩnh của từng tab (anh 19-10: "tự hiện fullscreen video … có cả nút play và tua lại")
      let noInline = false; try { noInline = sessionStorage.getItem('d3-noinline') === '1'; } catch (e) {}
      const prep = (v) => { v.muted = true; v.defaultMuted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); };
      const kill = (v) => {
        noInline = true; try { sessionStorage.setItem('d3-noinline', '1'); } catch (e) {}
        try { if (v.webkitDisplayingFullscreen && v.webkitExitFullscreen) v.webkitExitFullscreen(); } catch (e) {}
        try { if (document.fullscreenElement === v && document.exitFullscreen) document.exitFullscreen(); } catch (e) {}
        try { if (document.pictureInPictureElement === v) document.exitPictureInPicture(); } catch (e) {}
        vids.forEach((x) => { if (x) { x.pause(); x.classList.remove('is-playing'); } });
      };
      const src = (v, pre) => { if (!v || v.dataset.on) return; v.dataset.on = 1; if (pre) v.preload = 'auto'; v.src = phone && v.dataset.srcM ? v.dataset.srcM : v.dataset.src; };
      const setCap = (i, t) => {
        const list = caps[i]; if (!cap || !list.length) return;
        let k = 0; list.forEach((m, j) => { if (t + 0.05 >= m.t) k = j; });
        const s = list[k].s; if (capT.textContent === s) return;
        if (still) { capT.textContent = s; return; }
        cap.classList.add('is-swap'); setTimeout(() => { capT.textContent = s; cap.classList.remove('is-swap'); }, 170);
      };
      const play = (i, restart) => {
        const v = vids[i]; if (!v || still || noInline) return;
        src(v); prep(v); v.loop = !auto;
        if (restart) { try { v.currentTime = 0; } catch (e) {} }
        const p = v.play(); if (p && p.catch) p.catch(() => {});
      };
      const loop = () => {
        raf = 0; const v = vids[cur], b = bars[cur];
        if (v && b && v.duration) b.style.transform = `scaleX(${clamp(v.currentTime / v.duration)})`;
        if (seen && !still) raf = requestAnimationFrame(loop);
      };
      function show(i, user) {
        if (user) { auto = false; }
        cur = i;
        items.forEach((it, j) => it.classList.toggle('is-on', j === i));
        tabs.forEach((t, j) => { if (t) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; } });
        panes.forEach((p, j) => p.classList.toggle('is-on', j === i));
        notes.forEach((p, j) => p.classList.toggle('is-on', j === i));
        vids.forEach((v, j) => { if (v && j !== i && !v.paused) v.pause(); });
        bars.forEach((b) => { if (b) b.style.transform = 'scaleX(0)'; });
        if (cap) cap.dataset.tone = items[i].dataset.tone || 'pulse';
        setCap(i, 0);
        if (seen) play(i, true);
      }
      vids.forEach((v, j) => {
        if (!v) return;
        v.addEventListener('playing', () => { if (noInline) { kill(v); return; } v.classList.add('is-playing'); });
        v.addEventListener('webkitbeginfullscreen', () => kill(v));
        v.addEventListener('enterpictureinpicture', () => kill(v));
        document.addEventListener('fullscreenchange', () => { if (document.fullscreenElement === v) kill(v); });
        v.addEventListener('timeupdate', () => {
          if (j !== cur) return; setCap(j, v.currentTime);
          if (auto && v.duration && v.currentTime / v.duration > 0.55) src(vids[(j + 1) % n], true);   // tải trước tab kế
        });
        v.addEventListener('ended', () => { if (j === cur && auto) show((j + 1) % n); });
      });
      const stageEl = sec.querySelector('.d3-mt__stage') || sec;
      // điện thoại: danh sách tab nằm DƯỚI sân khấu → khách bấm tab khi sân khấu đã trôi lên quá nửa thì đưa sân khấu về màn (do khách bấm, không tự cuộn)
      const bring = () => {
        if (!phone) return; const r = stageEl.getBoundingClientRect(), vis = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
        if (vis < r.height * 0.6) window.scrollTo({ top: scrollY + r.top - 72, behavior: still ? 'auto' : 'smooth' });
      };
      tabs.forEach((t, j) => {
        if (!t) return;
        t.addEventListener('click', () => { bring(); if (j === cur && !auto) return; show(j, true); });
        t.addEventListener('keydown', (e) => {
          const k = e.key; let to = -1;
          if (k === 'ArrowDown' || k === 'ArrowRight') to = (j + 1) % n; else if (k === 'ArrowUp' || k === 'ArrowLeft') to = (j - 1 + n) % n;
          else if (k === 'Home') to = 0; else if (k === 'End') to = n - 1;
          if (to < 0) return; e.preventDefault(); show(to, true); tabs[to].focus();
        });
      });
      watch(stageEl, (on) => {
        seen = on; const v = vids[cur];
        if (on) { if (noInline) return; if (v && v.dataset.on) { prep(v); const p = v.play(); if (p && p.catch) p.catch(() => {}); } else play(cur, true); if (!raf && !still) raf = requestAnimationFrame(loop); }
        else { if (v) v.pause(); }
      }, { threshold: 0.35 });
      show(0);
    });
  }

  /* ---------- 5. timeline crossfade ---------- */
  function timeline(root) {
    $$('[data-d3-tl]', root).forEach((sec) => {
      if (sec.__d3) return; sec.__d3 = 1;
      const imgs = $$('.d3-tl__img', sec), chips = $$('.d3-tl__chip', sec), n = chips.length; if (!n) return;
      const track = sec.querySelector('.d3-tl__track'), meter = sec.querySelector('.d3-tl__mt'), body = sec.querySelector('.d3-tl__body');
      const f = { when: sec.querySelector('.d3-tl__when'), t: sec.querySelector('.d3-tl__t'), s: sec.querySelector('.d3-tl__s') };
      let cur = 0, timer = 0, ran = false;
      const stop = () => { if (timer) { clearInterval(timer); timer = 0; } };
      function show(i, user) {
        if (user) { stop(); ran = true; }
        i = (i + n) % n; const same = i === cur; cur = i;
        imgs.forEach((im, j) => im.classList.toggle('is-on', j === i));
        chips.forEach((c, j) => { c.classList.toggle('is-on', j === i); c.classList.toggle('is-done', j < i); c.setAttribute('aria-selected', j === i ? 'true' : 'false'); c.tabIndex = j === i ? 0 : -1; });
        if (track) track.style.setProperty('--p', n > 1 ? i / (n - 1) : 1);
        if (meter) meter.style.setProperty('--b', chips[i].dataset.b || '0.2');
        if (same) return;
        const d = chips[i].dataset, put = () => { f.when.textContent = d.when; f.t.textContent = d.title; f.s.textContent = d.sub || ''; };
        if (still || !body) { put(); return; }
        body.classList.add('is-swap'); setTimeout(() => { put(); body.classList.remove('is-swap'); }, 200);
      }
      chips.forEach((c, j) => {
        c.addEventListener('click', () => show(j, true));
        c.addEventListener('keydown', (e) => {
          const k = e.key; let to = -1;
          if (k === 'ArrowRight') to = j + 1; else if (k === 'ArrowLeft') to = j - 1; else if (k === 'Home') to = 0; else if (k === 'End') to = n - 1;
          if (to < 0) return; e.preventDefault(); show(to, true); chips[(to + n) % n].focus();
        });
      });
      const st = sec.querySelector('.d3-tl__stage');
      if (st) {
        let x0 = null;
        st.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
        st.addEventListener('pointerup', (e) => { if (x0 == null) return; const dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1), true); });
        st.addEventListener('pointercancel', () => { x0 = null; });
      }
      if (still) { show(n - 1); return; }   // prosecutor dr4 P1-1: giảm chuyển động = mốc cuối (Week 12)
      show(0);
      watch(st || sec, (on, o) => {
        if (!on || ran) return; ran = true; if (o) o.disconnect();
        setTimeout(() => { timer = setInterval(() => { if (cur >= n - 1) { stop(); return; } show(cur + 1); }, 1700); }, 700);
      }, { threshold: 0.55 });
    });
  }

  /* ---------- 5b. giải pháp đã thất bại: tự chạy MỘT lượt qua giải pháp cũ rồi dừng ở tab thắng ---------- */
  function fails(root) {
    $$('[data-d3-fs]', root).forEach((sec) => {
      if (sec.__d3) return; sec.__d3 = 1;
      const items = $$('.d3-fs__item', sec), imgs = $$('.d3-fs__img', sec), notes = $$('.d3-fs__note', sec), n = items.length; if (!n) return;
      const tabs = items.map((it) => it.querySelector('[role="tab"]'));
      const cap = sec.querySelector('.d3-fs__cap'), capT = cap && cap.querySelector('span'), stage = sec.querySelector('.d3-fs__stage');
      let cur = 0, timer = 0, ran = false;
      const stop = () => { if (timer) { clearInterval(timer); timer = 0; } };
      function show(i, user) {
        if (user) { stop(); ran = true; }
        i = (i + n) % n; const same = i === cur; cur = i;
        items.forEach((it, j) => it.classList.toggle('is-on', j === i));
        tabs.forEach((t, j) => { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
        imgs.forEach((im, j) => im.classList.toggle('is-on', j === i));
        notes.forEach((p, j) => p.classList.toggle('is-on', j === i));
        if (!cap || same) return;
        const win = items[i].classList.contains('d3-fs__item--win'), txt = tabs[i].dataset.where || '';
        if (still) { capT.textContent = txt; cap.classList.toggle('is-win', win); return; }
        cap.classList.add('is-swap'); setTimeout(() => { capT.textContent = txt; cap.classList.toggle('is-win', win); cap.classList.remove('is-swap'); }, 170);
      }
      const bring = () => {   // điện thoại: chip nằm TRÊN ảnh, ảnh trôi lên quá nửa thì đưa về màn (do khách bấm)
        if (!phone || !stage) return; const r = stage.getBoundingClientRect(), vis = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
        // AD dr4 vòng 2: hàng lý do nằm TRÊN ảnh → ảnh hay ở nửa dưới / ngoài màn khi bấm → kéo ảnh lên dưới thanh đầu trang
        if (vis < r.height * 0.6 || r.top > innerHeight * 0.5) window.scrollTo({ top: scrollY + r.top - 80, behavior: still ? 'auto' : 'smooth' });
      };
      tabs.forEach((t, j) => {
        t.addEventListener('click', () => { bring(); show(j, true); });
        t.addEventListener('keydown', (e) => {
          const k = e.key; let to = -1;
          if (k === 'ArrowDown' || k === 'ArrowRight') to = j + 1; else if (k === 'ArrowUp' || k === 'ArrowLeft') to = j - 1; else if (k === 'Home') to = 0; else if (k === 'End') to = n - 1;
          if (to < 0) return; e.preventDefault(); show(to, true); tabs[(to + n) % n].focus();
        });
      });
      if (stage) {
        let x0 = null;
        stage.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
        stage.addEventListener('pointerup', (e) => { if (x0 == null) return; const dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1), true); });
        stage.addEventListener('pointercancel', () => { x0 = null; });
      }
      // prosecutor dr4 P1-1: giảm chuyển động = trạng thái CUỐI (tab thắng), không phải tab đầu
      if (still) { show(n - 1); return; }
      show(0);
      watch(stage || sec, (on, o) => {
        if (!on || ran) return; ran = true; if (o) o.disconnect();
        setTimeout(() => { timer = setInterval(() => { if (cur >= n - 1) { stop(); return; } show(cur + 1); }, 3200); }, 900);
      }, { threshold: 0.55 });
    });
  }

  /* ---------- 6. vòng 90 ngày theo cuộn ---------- */
  function ring(root) {
    $$('[data-d3-ring]', root).forEach((box) => {
      if (box.__d3 || still) return; box.__d3 = 1;
      const arc = box.querySelector('.d3-pr__arc'), num = box.querySelector('[data-d3-days]'), ms = $$('.d3-pr__m', box);
      const days = +box.dataset.days || 90;
      const tick = () => {
        const r = box.getBoundingClientRect(), vh = innerHeight;
        if (r.bottom < -200 || r.top > vh + 200) return;
        const p = clamp((vh * 0.88 - r.top) / (vh * 0.5));
        if (arc) arc.style.strokeDashoffset = String(100 - p * 100);
        if (num) num.textContent = String(Math.max(1, Math.round(p * days)));
        ms.forEach((m, j) => m.classList.toggle('is-on', p >= (ms.length > 1 ? j / (ms.length - 1) : 1) - 0.001));
      };
      onScroll(tick);
    });
  }

  /* ---------- 7. ô chi tiết nghiêng (chuột) ---------- */
  function tilt(root) {
    if (still || !mm('(hover: hover) and (pointer: fine)')) return;
    $$('.d3-det [data-d3-tilt]', root).forEach((t) => {
      if (t.__d3) return; t.__d3 = 1;
      t.addEventListener('pointermove', (e) => {
        const r = t.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        t.style.setProperty('--ry', `${(x * 9).toFixed(2)}deg`); t.style.setProperty('--rx', `${(-y * 9).toFixed(2)}deg`);
      });
      t.addEventListener('pointerleave', () => { t.style.setProperty('--rx', '0deg'); t.style.setProperty('--ry', '0deg'); });
    });
  }

  /* ---------- 8. nút mua giữa trang [data-d3-cta] → cuộn về khối mua chính (form / claim của buybox giữ nguyên logic) ---------- */
  function ctas(root) {
    $$('[data-d3-cta]', root).forEach((b) => {
      if (b.__d3) return; b.__d3 = 1;
      b.addEventListener('click', (e) => {
        const t = document.querySelector('.o3-bb .o3-atc') || document.querySelector('.o3-bb'); if (!t) return; e.preventDefault();
        window.scrollTo({ top: t.getBoundingClientRect().top + scrollY - Math.round(innerHeight * 0.35), behavior: still ? 'auto' : 'smooth' });
      });
    });
  }

  const init = (root) => { ctas(root); reveal(root); ticker(root); stage(root); mtabs(root); timeline(root); fails(root); ring(root); tilt(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
